var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('w-data-table',{attrs:{"headers":_vm.headers,"actions":_vm.actions,"loading":_vm.loading,"search":_vm.search,"items":_vm.paySections,"identity":"code","item-class":_vm.rowColor},on:{"click:row":_vm.itemClick},scopedSlots:_vm._u([{key:"item.code",fn:function(ref){
var item = ref.item;
return [_c('w-chip',{attrs:{"text":item.code}})]}},{key:"item.label",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"bold":"","text":item.label}})]}},{key:"item.labelInArabic",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"bold":"","text":item.labelInArabic}})]}},{key:"item.type",fn:function(ref){
var item = ref.item;
return [(item.type)?_c('w-chip',{attrs:{"color":"teal","text":_vm.$t(("pay_section.type_" + (item.type)))}}):_vm._e()]}},{key:"item.variable",fn:function(ref){
var item = ref.item;
return [(item.variable)?_c('w-inline-text',{attrs:{"text":_vm.$t(("pay_section.variable_" + (item.variable)))}}):_vm._e()]}},{key:"item.isAbsenceRetenue",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("pay_section.boolean_" + (item.isAbsenceRetenue))))+" ")]}},{key:"item.imposable",fn:function(ref){
var item = ref.item;
return [_c('w-chip',{attrs:{"outlined":"","text":_vm.$t(("pay_section.imposable_" + (item.imposable)))}})]}},{key:"item.cotisable",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("pay_section.boolean_" + (item.cotisable))))+" ")]}},{key:"item.brute",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("pay_section.boolean_" + (item.brute))))+" ")]}},{key:"item.regularization",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("pay_section.boolean_" + (item.regularization))))+" ")]}},{key:"item.conge",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("pay_section.boolean_" + (item.conge))))+" ")]}},{key:"item.formule",fn:function(ref){
var item = ref.item;
return [_c('str-formula',{attrs:{"formula":item.formule}})]}},{key:"item.blockFormula",fn:function(ref){
var item = ref.item;
return [(item.formula)?_c('span',[_vm._v(" "+_vm._s(_vm.$t(("pay_section.boolean_" + (item.blockFormula))))+" ")]):_vm._e()]}},{key:"item.decimalNumber",fn:function(ref){
var item = ref.item;
return [(item.formula)?_c('span',[_vm._v(" "+_vm._s(item.decimalNumber)+" ")]):_vm._e()]}},{key:"item.viewFormat",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":item.viewFormat}})]}},{key:"item.fixeInitial",fn:function(ref){
var item = ref.item;
return [(item.fixeInitial && item.fixeInitial !== '0')?_c('w-inline-text',{attrs:{"text":_vm.$t(("pay_section.view_format_" + (item.fixeInitial)))}}):_vm._e()]}},{key:"item.initValue",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":item.initValue}})]}},{key:"item.minValue",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":item.minValue}})]}},{key:"item.maxValue",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":item.maxValue}})]}},{key:"item.notWritable",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("pay_section.boolean_" + (item.notWritable))))+" ")]}},{key:"item.bulteinePrintable",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":_vm.$t(("pay_section.bulteine_printable_" + (item.bulteinePrintable)))}})]}},{key:"item.basePrint",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":item.basePrint}})]}},{key:"item.tauxPrint",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":item.tauxPrint}})]}},{key:"item.journalPrintable",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("pay_section.boolean_" + (item.journalPrintable))))+" ")]}},{key:"item.stateChargePrintable",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("pay_section.boolean_" + (item.stateChargePrintable))))+" ")]}},{key:"item.recapPrintable",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(("pay_section.boolean_" + (item.recapPrintable))))+" ")]}},{key:"item.recapBase",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":item.recapBase}})]}},{key:"item.comptaCompte",fn:function(ref){
var item = ref.item;
return [_c('w-inline-text',{attrs:{"text":item.comptaCompte}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }